// storage-operation.factory.ts
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CloudTypes } from "src/app/core/models/globals";
import { IStorageOperations } from "./storage-operations.interface";
import { AzureStorageOperations } from "./azure-storage-operations";
import { OnPremiseStorageOperations } from "./onpremise-storage-operations";
import { AwsStorageOperations } from "./aws-storage-operations";
import { OracleStorageOperations } from "./oracle-storage-operations";
import { GcpStorageOperations } from "./gcp-storage-operations";

// Import services
import { StorageService } from "src/app/core/services/storage.service";
import { StorageDataTransferService } from "src/app/core/services/storage-data-transfer.service";
import { StorageOracleService } from "src/app/core/services/storage-oracle.service";
import { GoogleCloudService } from "src/app/core/services/google-cloud.service";
import { AwsCloudService } from "src/app/core/services/aws-cloud.service";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { HeaderService } from "src/app/core/services/header.service";
import { ManageStorageLogsService } from "src/app/core/services/manage-storage-logs.service";
import { AzureStorageType } from "src/app/core/models/storage";
import { EnvironmentService } from "src/app/core/services/environment.service";

@Injectable({
  providedIn: 'root'
})
export class StorageStrategyFactory {
  
  constructor(
    private storageService: StorageService, 
    private http: HttpClient,
    private oracleService: StorageOracleService,
    private gcpService: GoogleCloudService,
    private awsService: AwsCloudService,
    private azureService: StorageDataTransferService,
    private deploymentService: DeploymentService,
    private env: EnvironmentService,
    private headerService: HeaderService,
    private storageLogService: ManageStorageLogsService
  ) {}

  getStrategy(cloudType: CloudTypes, deploymentName?: string, activeStore?: string, dirName?: string): IStorageOperations {
    // Check if it's workstore path (OnPremise handling)
    if (dirName && dirName.includes(this.env.envVariables.workStoreRoute)) {
      return new OnPremiseStorageOperations(this.storageService, this.storageLogService, this.deploymentService, this.env, this.http);
    }
    
    switch(cloudType) {
        case CloudTypes.OnPremise:
            return new OnPremiseStorageOperations(this.storageService, this.storageLogService, this.deploymentService, this.env, this.http);
          
        case CloudTypes.MicrosoftAzure:
            const isBlob = this.checkIfStorageIsBlobForAzure(deploymentName, activeStore);
            return new AzureStorageOperations(this.azureService, this.storageLogService, this.env, isBlob);
        
        case CloudTypes.AWS:
            return new AwsStorageOperations(this.awsService,this.headerService,this.storageLogService);
        
        case CloudTypes.Oracle:
            return new OracleStorageOperations(this.oracleService,this.headerService,this.storageLogService);
        
        case CloudTypes.Google:
            return new GcpStorageOperations(this.gcpService,this.headerService,this.storageLogService);
        
        default:
            throw new Error(`Unsupported cloud type: ${cloudType}`);
    }
  }
  
  private checkIfStorageIsBlobForAzure(deploymentName?: string, activeStore?: string): boolean {
    if (!deploymentName || activeStore !== 'SyncStore') {
      return false;
    }
    
    const deployment = this.deploymentService.getProfileInfoFromSubject(deploymentName);
    return deployment?.storageType === AzureStorageType.TxtBlobStorage;
  }
}